import { useI18n } from 'contexts/i18n';
import { FC } from 'react';
import { headerConfig } from 'utils/headerConfig';
import { useActiveTab } from 'utils/hooks';
import { Styled, DesktopNavProps } from '.';

export const DesktopNavMenu: FC<DesktopNavProps> = ({ tabs }) => {
  const i18n = useI18n();

  const { activeTab } = useActiveTab(headerConfig.currentlyActiveTab);

  return (
    <Styled.DesktopNavigationItemListContainer>
      <Styled.DesktopNavigationItemList>
        {tabs.map(tab => {
          return (
            <Styled.AppName
              href={tab.link}
              key={tab.link}
              isActive={tab.label === activeTab}
            >
              {i18n[tab.label]}
            </Styled.AppName>
          );
        })}
      </Styled.DesktopNavigationItemList>
    </Styled.DesktopNavigationItemListContainer>
  );
};
